import { render, staticRenderFns } from "./config-general.vue?vue&type=template&id=5fe2b970&scoped=true"
import script from "./config-general.vue?vue&type=script&lang=js"
export * from "./config-general.vue?vue&type=script&lang=js"
import style0 from "./config-general.vue?vue&type=style&index=0&id=5fe2b970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe2b970",
  null
  
)

export default component.exports